
















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { QuestelServicesClient } from '@questelservices/common';
import DataSource from 'devextreme/data/data_source';
import {
  DxColumn,
  DxDataGrid,
  DxPaging,
  DxScrolling,
  DxStateStoring
} from 'devextreme-vue/data-grid';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import String from '@/utilities/String';

@Component({
  components: {
    DxColumn,
    DxDataGrid,
    DxPaging,
    DxPopup,
    DxScrolling,
    DxStateStoring,
    DxToolbarItem
  }
})
export default class PhaseHistory extends Vue {
  private readonly client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');

  @Prop({ required: true })
  visible!: boolean;

  @Prop({ required: true })
  lineItem!: Guid;

  @Watch('lineItem')
  async onLineItemChanged() {
    await this.dataSource.reload();
  }

  get dataSource() {
    return new DataSource({
      key: 'InvoiceLineItemPhaseSettingId',
      loadMode: 'raw',
      load: () => {
        if (String.isNullOrEmpty(this.lineItem)) {
          return [];
        }

        return this.client.get(`/api/InvoiceLineItems/${this.lineItem}/phase-settings`);
      }
    });
  }

  get closeButtonOptions() {
    return {
      text: 'Close',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.close
    };
  }

  onCellPrepared(e: any) {
    if (e.rowType === 'data' && e.column.dataField === 'PhaseSetBy') {
      e.cellElement.title = e.text;
    }
  }

  onRowPrepared(e: any) {
    if (e.rowType === 'data') {
      e.rowElement.style['background-color'] = e.data.PhaseRgbHex;
    }
  }

  onHiding() {
    this.close();
  }

  close() {
    this.$emit('hiding');
  }
}
